import { useContext } from "react";
import { EventCreationContext } from "../../event_creation";
import DurationComponent from "../duration_picker";

export function EventDurationComponent() {
	const creation_context = useContext(EventCreationContext);

	// const [input, setInput] = useState(creation_context.state.end);

	return (
		<DurationComponent
			duration_ms={creation_context.state.duration_ms}
			updateFunc={(val) => {
				creation_context.setState({
					duration_ms: val,
				});
			}}
		/>
	);
}
